import { ObjectContainerClientT, ObjectTypeClientT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext } from 'react';
import BrandingService from '../../../../../services/branding.service';
import { AppContext } from '../../../../../state/app.state';
import { objectTypePropertySorting } from '../../../../../utils/objectType.helper';
import { ToggleValuesT } from '../ObjectView';

type ObjectViewButtonsProps={
    selectedObject?: ObjectContainerClientT;
    setShowDescription: (value: boolean) => void;
    showDescription: boolean;
    showIframeOne: boolean;
    showImages: boolean;
    showDocuments: boolean;
    showVideo: boolean;
    showIframeTwo: boolean;
    showInterestForm: boolean;
    types?: ObjectTypeClientT[];
    toggleShow: (value: ToggleValuesT) => void;
};

const ObjectViewButtons: React.FC<ObjectViewButtonsProps> = ({ selectedObject, setShowDescription, showDescription, types, showImages, showDocuments, showIframeOne, toggleShow, showVideo, showIframeTwo, showInterestForm }): ReactElement => {
    const { state, favoriteState, presentationState } = useContext(AppContext);

    const hasDescription = (): boolean => {
        return !!(selectedObject && selectedObject.data
            .slice()
            .filter(v => v.value !== null)
            .filter(v => types?.find(t => t.id === selectedObject.objectTypeId) ? types?.find(t => t.id === selectedObject.objectTypeId)?.properties.find(p => v.propId === p.id) : true)
            .sort(objectTypePropertySorting)
            .map(d => {
                const property = types?.find(t => t.id === selectedObject.objectTypeId)?.properties.find(p => p.id === d.propId);

                return ({ ...property, ...d });
            })
            .filter(d => d.type === 'description' || d.type === 'richDescription')
            .filter(d => d.value !== '' && (d.value as string).toString().length > 0)?.length > 0);
    };

    const isFavored = (): boolean => {
        return (!!selectedObject && !!favoriteState?.isFavored(selectedObject.id));
    };

    const toggleFavorite = (): void => {
        if (!selectedObject) {
            return;
        }

        if (!isFavored()) {
            favoriteState?.addFavorite(selectedObject.id);
        }
        else {
            favoriteState?.removeFavorite(selectedObject.id);
        }
    };

    return useObserver(() => (
        <> {selectedObject &&
            <>
                <div className='bv-objectview-buttons'>

                    {selectedObject.imageCollectionId &&
                        <ObjectViewButton inactive={showImages} onClick={():void => toggleShow('images')} label={'Bilder'}/>}
                    {hasDescription() &&
                            <ObjectViewButton inactive={showDescription} onClick={(): void => toggleShow('description')} label={'Beskrivning'} />}

                    {state?.project?.config?.favorites &&
                        <ObjectViewButton onClick={toggleFavorite} inactive={isFavored()} onClickOverride={true} label={isFavored() ? 'Sparad' : 'Spara'}/>}

                    {selectedObject.iframeOneId &&
                        <ObjectViewButton inactive={showIframeOne} onClick={():void => toggleShow('iframe1')} label={state?.project?.tours?.find(t => t.id === selectedObject.iframeOneId)?.label || 'IFrame1'} />}
                    {selectedObject.iframeTwoId &&
                        <ObjectViewButton inactive={showIframeTwo} onClick={():void => toggleShow('iframe2')} label={state?.project?.tours?.find(t => t.id === selectedObject.iframeTwoId)?.label || 'IFrame2'}/>}

                    {selectedObject.videoCollectionId &&
                        <ObjectViewButton inactive={showVideo} onClick={():void => toggleShow('video')} label={'Video'}/>}

                    {selectedObject.documentCollectionId && selectedObject.documentCollectionId &&
                        <ObjectViewButton inactive={showDocuments} onClick={():void => toggleShow('documents')} label={'Dokument'}/>}

                    {state?.project?.config?.shareObject &&
                        <ObjectViewButton label={'Dela'} onClick={(): void => {
                            state.setShareLink({ shareModalText:`Dela objekt ${selectedObject.name || ''} på ${state.project?.name || ''}`, value: `https://${window.location.hostname}/bv/v3/project/${state.project?.id || ''}?objectId=${selectedObject.id}` });
                            presentationState?.setShowShareModal(true);
                        }}/>}
                    {state?.project?.interestForm &&
                        <ObjectViewButton inactive={showInterestForm} label={'Intresseanmälan'} onClick={():void => toggleShow('interestform')}/>}
                </div>

                {(BrandingService.check(['obos']) || selectedObject.externalUrl) &&
                    <ObjectViewButtonFullwidth
                        label={BrandingService.check(['obos']) ? 'Läs mer och anmäl intresse' : 'Läs mer'}
                        onClick={(): void => {
                            const isActive = state?.pymContextFrame?.active;
                            const hasSendMessage = !!state?.pymContextFrame?.sendMessage;
                            console.log('click', { isActive, hasSendMessage, externalUrl: selectedObject.externalUrl });

                            if (selectedObject.externalUrl) {
                                const link = document.createElement('a');
                                link.target = '_blank';
                                link.href = selectedObject.externalUrl || '';
                                link.addEventListener('click', (event) => {

                                    return false;
                                });
                                link.click();
                                link.remove();
                            }
                            else if (state?.pymContextFrame?.active && state?.pymContextFrame.sendMessage) {
                                console.log('send navigate message', {
                                    propertyID: selectedObject.externalSyncId,
                                    url: '#property-details'
                                });
                                state?.pymContextFrame.sendMessage('navigate',
                                    JSON.stringify({
                                        propertyID: selectedObject.externalSyncId,
                                        url: '#property-details'
                                    }));
                            }
                        }}
                    />}
            </>}
        </>

    ));
};


export const ObjectViewButton: React.FC<{onClick?: () => void; label: string, inactive?: boolean, onClickOverride?: boolean; }> = ({ label, onClick, inactive = false, onClickOverride = false }) => <div onClick={(inactive && !onClickOverride) ? undefined : onClick} className={`bv-objectview-button ${inactive ? 'bv-objectview-button-inactive' : ''}`} style={{ cursor: inactive && !onClickOverride ? 'default' : 'pointer' }}><ObjectViewButtonContent>{label}</ObjectViewButtonContent></div>;
const ObjectViewButtonContent: React.FC = ({ children }) => <div className='bv-objectview-button-content'>{children}</div>;
export const ObjectViewButtonFullwidth: React.FC<{onClick?: () => void; label: string}> = ({ label, onClick }) => <div onClick={onClick} className='bv-objectview-button bv-objectview-button--fullwidth bv-objectview-button--external-link'>{label}</div>;

export default ObjectViewButtons;